import Image from 'next/image';
import Link from 'next/link';
import { bottomImage3, filmImage, medicationFooter } from '../../assets/images';
import { ArrowBlackLong, WhiteCheckMark } from '../../assets/icons';
const MedicationFooter = ({ path }) => {
  return (
    <div className='bottomImageTwoWrapper tw-h-[680px]'>
      <div className='theFilm tw-flex tw-items-center'>
        <div className='theFilmContent'>
          <h2 className='filmHeading'>
            Get the care you need —
            <br className='the-line-break' /> without the wait.
          </h2>
          <div className='theCtaList'>
            {ctaGoals.map((item) => (
              <div key={item.id} className='theListItem'>
                <span>
                  <WhiteCheckMark />
                </span>
                <span
                  style={{
                    color: '#FFFFFF',
                    fontWeight: '500',
                    fontSize: '0.875rem',
                  }}
                >
                  {item.text}
                </span>
              </div>
            ))}
          </div>
          <Link href={`${path ? path : '/services'}`}>
            <div className='hero-home-new-cta'>
              {' '}
              <span className='theFilmCta tw-font-medium'>
                 Begin Medical Assessment 
                <ArrowBlackLong />
              </span>
            </div>
          </Link>
        </div>
      </div>
      <Image
        src={medicationFooter}
        layout='fill'
        objectFit='cover'
        alt='a woman sitting comfortably at home'
      />
    </div>
  );
};

export default MedicationFooter;
const ctaGoals = [
  { id: 1, text: 'Reviewed by licensed provider' },
  { id: 2, text: 'Prescription sent fast' },
  { id: 3, text: 'Secure & confidentials' },
];
